import AccosBar from '@/components/accosbar/AccosBar.vue'
import { CURRENTCOMPONTENT } from '@/composables/helpers'
import type { IAccosBarDto } from '@/composables/interfaces/apiInterfaces'
import type { IAccosBarData, ILocation, IRoom } from '@/composables/interfaces/appInterfaces'
import { AccosBarDataQueryString, FilterPageUrl, PetsAllowedAmenityId } from '@/constants'
import { ref, watch } from 'vue'
import { filtersData, filterStore } from './filter.store'

export const location = ref<ILocation | null>(null)
export const date = ref<(Date | null)[] | null | undefined>(null)
export const rooms = ref<IRoom[]>([{ adults: 2, children: 0, childrenAges: [] }])
export const pets = ref<{ hasPets: boolean; message: string }>({ hasPets: false, message: '' })

/**
 * variable which stores full area table in current language
 */
export const areas = ref<IAccosBarDto[] | null>([])

/**
 * ref value which stores every single data of accosbar
 *
 * Note: ref value changes if one of the values in the object change.
 */
export const accosBarData = ref({ location, date, rooms, pets })

export const popupVisible = ref(false)

export function fillAccosBarDataFromUrlState(): void {
  const urlParams = new URLSearchParams(window.location.search)
  const accosBarDataFromQueryParams = urlParams.get(AccosBarDataQueryString)
  if (accosBarDataFromQueryParams != null) {
    const x = atob(accosBarDataFromQueryParams)
    const data = JSON.parse(x) as IAccosBarData
    //prevents that same state is pushed to the url and a new history entry is made
    if (x != JSON.stringify(accosBarData.value)) {
      location.value = data.location
      date.value = data.date?.map((dateStr) => {
        if (dateStr != null) {
          return new Date(dateStr.toString())
        }
        return null
      })
      rooms.value = data.rooms
      pets.value = data.pets
    }
  }
}

watch(
  accosBarData.value,
  () => {
    const url = new URL(window.location.toString())
    const data = btoa(JSON.stringify(accosBarData.value))
    if (url.pathname == FilterPageUrl && CURRENTCOMPONTENT == AccosBar) {
      if (url.searchParams.get(AccosBarDataQueryString) != null && url.searchParams != null) {
        url.searchParams.set(AccosBarDataQueryString, data)
      } else {
        url.searchParams.append(AccosBarDataQueryString, data)
      }
      window.history.replaceState({}, '', url)
    }
  },
  { deep: true }
)

watch(location, (newLocation) => {
  filterStore.value.areaId = newLocation?.areaId ?? 0
})

watch(
  //done to keep pets.value.hasPets and filterStore.value.amenityIds in sync
  () => pets.value.hasPets,
  () => {
    //checking if PetAmenityId is a active amenityid
    if (filtersData.value?.amenities.map((x) => x.id).includes(PetsAllowedAmenityId)) {
      if (pets.value.hasPets) {
        if (!filterStore.value.amenityIds.includes(PetsAllowedAmenityId)) {
          filterStore.value.amenityIds.push(PetsAllowedAmenityId)
        }
      } else {
        if (filterStore.value.amenityIds.includes(PetsAllowedAmenityId)) {
          const x = filterStore.value.amenityIds.findIndex((x) => x == PetsAllowedAmenityId)
          filterStore.value.amenityIds.splice(x)
        }
      }
    }
  }
)
